import { createContext } from 'react';

import {
  CustomColorPalette,
  ColorPalette,
} from '../../core/types/color-palette.js';

export const HistogramColorPaletteContext = createContext<
  ColorPalette | CustomColorPalette
>('categorical');

HistogramColorPaletteContext['displayName'] = 'HistogramColorPaletteContext';
